module.exports = __webpack_public_path__ + "img/10.f1eedf97.jpg";